import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Check } from 'lucide-react';
const steps = [{
  label: 'Profile',
  path: '/profile'
}, {
  label: 'Results',
  path: '/results'
}, {
  label: 'Plan',
  path: '/plan'
}, {
  label: 'Review',
  path: '/review'
}];
export function Stepper() {
  const {
    pathname
  } = useLocation();
  const current = pathname === '/confirmed' ? steps.length : steps.findIndex(s => s.path === pathname);
  return <nav aria-label="Progress" data-id="element-126" data-mp="1g80pci4stlc0">
      <p className="font-mono text-xs text-muted-foreground md:hidden" data-id="element-127" data-mp="1l4isxeoe7dmr">
        {current >= steps.length ? 'Order placed' : `Step ${current + 1} of ${steps.length}`}
      </p>
      <ol className="hidden items-center gap-2 md:flex" data-id="element-128" data-mp="1p8yvb5yss2x8">
        {steps.map((step, i) => {
        const done = i < current;
        const active = i === current;
        const content = <span className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-sm transition-colors ${active ? 'bg-white/10 text-foreground' : done ? 'text-foreground hover:bg-white/5' : 'text-muted-foreground'}`} data-id="element-129" data-mp="35kvvv6alon33">
              <span className={`flex size-5 items-center justify-center rounded-full font-mono text-[10px] ${done ? 'bg-[#9b8cf0] text-[#0f1017]' : active ? 'border border-[#9b8cf0] text-[#c4baff]' : 'border border-white/15'}`} data-id="element-130" data-mp="3vuet90unebn9">
                {done ? <Check className="size-3" data-id="element-131" data-mp="3hyt854rjcc04" /> : i + 1}
              </span>
              {step.label}
            </span>;
        return <li key={step.path} className="flex items-center gap-2" aria-current={active ? 'step' : undefined} data-id="element-132" data-mp="3863v45gc6q2o" data-mpi={i}>
              {done && current < steps.length ? <Link to={step.path} data-id="element-133" data-mp="335pqkxdy1y9e">{content}</Link> : content}
              {i < steps.length - 1 && <span className="h-px w-4 bg-white/15" aria-hidden="true" data-id="element-134" data-mp="2y7xvxvlwzy1i" />}
            </li>;
      })}
      </ol>
    </nav>;
}